import { gql } from "@apollo/client";

export const GET_SOLICITUDES_GESTION_LOGISTICA = gql`
query AllSolicitudesGestionLogistica (
    $skip: Int
    $take: Int
    $where: t_EvaluacionFilterInput  
    $order : [t_EvaluacionSortInput!] 
){
    allSolicitudesGestionLogistica(skip: $skip, take: $take, where: $where, order: $order ) {
        items {           
                idEvaluacion
                fechaDesde       
                fechaHasta
                tipoContrato
                clientePresupuesto              
                precioDiario  
                idDelegacion
                idCliente
                idUltimaInstanciaLogisticaNavigation{
                  idProveedorDistribuidorNavigation{
                    idDepositoNavigation{
                      descripcion
                    }
                  }
                  idGestionLogisticaEstadoNavigation{
                    descripcion
                    idGestionLogisticaEstado
                  }
                  fechaNotificacion
                  nroInstancia
                  idDistribucionOrigenNavigation{
                    idDistribucionOrigen
                    codigo
                  }
                  idCodigoPostalNavigation{
                    idCodigoPostal
                    cP
                  }
                  observacion
                  observacionLogistica
                }
                instanciaLogistica{
                  direccion
                  provincia
                  idProveedorDistribuidorNavigation{
                    idDepositoNavigation{
                      descripcion
                    }
                    proveedorMetodoCobroBulto {
                      fechaDesde
                      fechaHasta
                      precio
                    }
                    proveedorMetodoCobroKM {
                      fechaDesde
                      fechaHasta
                      valor
                    }
                    proveedorMetodoCobroKilo {
                      fechaDesde
                      fechaHasta
                      valor
                    }
                  }
                  idInstanciaLogistica
                  nroInstancia
                  idCodigoPostalNavigation{
                    idCodigoPostal
                    cP
                    localidad
                    idTipoZona
                    idTipoZonaNavigation {
                      descripcion
                    }
                  }
                  idGestionLogisticaEstadoNavigation{
                    descripcion
                    idGestionLogisticaEstado
                  }
                  idDistribucionOrigenNavigation{
                    idDistribucionOrigen
                    codigo
                  }
                  fechaNotificacion
                  idGestionUsuarioNavigation {
                    apellido
                    nombre
                  }                 
                  observacion
                  observacionLogistica
                  idUsuarioLogisticaNavigation{
                    apellido
                    nombre
                  }
                  fechaLogistica
                  idProveedorDistribuidorNavigation {
                    codigoSAP
                    razonSocial
                    idProveedorDistribuidor
                  }
                  envioEspecial
                  alertarZonaDesfavorable
                  idGestionLogisticaMotivoNavigation {
                    idGestionLogisticaMotivo
                    descripcion
                  }
                }
              t_EvaluacionPaciente {
                idPacienteNavigation {
                  idPaciente
                  codSAPPaciente
                  nombre
                  apellido
                  latitud
                  longitud
                  idCliente
                }
              }
        }
        pageInfo {
            hasNextPage
            hasPreviousPage
        }
        totalCount
    }
}
`;